/* eslint-disable complexity */
import { languageData } from "static/staticData/languageData.js";
import { certificationData } from "static/staticData/certidata.js";
import { getSortingOption } from "util/serverUtil";
import { capitalize } from "util/stringUtil";
const filterSlugGenerator = (selectedFilter) => {
  let ratingValue,
    recommValue,
    price,
    minPrice,
    maxPrice,
    workedWithSelected,
    photo,
    photoValue,
    lang,
    designation,
    langArrayString,
    designationArrayString,
    page;

  ratingValue = selectedFilter && selectedFilter["rating"];
  recommValue = selectedFilter && selectedFilter["recommendation"];
  price = selectedFilter && selectedFilter["price"];
  workedWithSelected = selectedFilter && selectedFilter["rep"];
  photo = selectedFilter && selectedFilter["photo"];
  lang = selectedFilter && selectedFilter["lang"];
  designation = selectedFilter && selectedFilter["designation"];
  page = selectedFilter && selectedFilter["pg"];

  minPrice = price && price.minPrice;
  maxPrice = price && price.maxPrice;
  workedWithSelected =
    workedWithSelected == "Buyers" ? "buyer" : workedWithSelected == "Sellers" ? "seller" : "";

  photoValue = photo == undefined || photo ? 1 : 0;

  langArrayString =
    lang &&
    lang
      .map((m) => m.lang)
      .join(";")
      .toLowerCase();
  const langQueryString =
    lang &&
    lang
      .map((m) => m.lang)
      .join("%2C")
      .toLowerCase();
  designationArrayString =
    designation &&
    designation
      .map((m) => m.certName)
      .join(";")
      .toLowerCase();
  const designationQueryString =
    designation &&
    designation
      .map((m) => m.certName)
      .join("%2C")
      .toLowerCase();

  const fliterGlobalSlugValues = {
    rating: ratingValue ? ratingValue : "",
    recommendation: recommValue ? recommValue : "",
    minPrice: minPrice ? minPrice : "",
    maxPrice: maxPrice ? maxPrice : "",
    rep: workedWithSelected ? workedWithSelected : "",
    photo: photoValue ? true : false,
    lang: langQueryString ? langQueryString : "",
    designation: designationQueryString ? designationQueryString : "",
    pg: page ? page : "",
  };
  const ratingSlug = ratingValue ? "/rating-" + ratingValue : "";
  const recommSlug = recommValue ? "/recommendation-" + recommValue : "";
  const priceSlug = minPrice && maxPrice ? "/price-" + minPrice + "_" + maxPrice : "";
  const workedWithSlug = workedWithSelected ? "/rep-" + workedWithSelected : "";

  const photoSlug = photo == undefined ? "/photo-" + photoValue : "/photo-" + photoValue;
  const langSlug = langArrayString ? "/lang-" + langArrayString : "";
  const designationSlug = designationArrayString ? "/designation-" + designationArrayString : "";
  const pageSlug = page ? "/pg-" + page : "";

  const fliterGlobalSlug =
    workedWithSlug +
    priceSlug +
    photoSlug +
    langSlug +
    designationSlug +
    ratingSlug +
    recommSlug +
    pageSlug;

  return [fliterGlobalSlug, fliterGlobalSlugValues];
};

const queryfilterObjectGenerator = (filterValues) => {
  let rating = filterValues.rating ? filterValues.rating : null;
  let recommendation = filterValues.recommendation ? filterValues.recommendation : null;
  let minPrice = filterValues.minPrice ? filterValues.minPrice : null;
  let maxPrice = filterValues.maxPrice ? filterValues.maxPrice : null;
  let rep = filterValues.rep ? filterValues.rep : null;
  let photo = filterValues.photoRealVal;
  let lang = filterValues.lang ? filterValues.lang : null;
  let designation = filterValues.designation ? filterValues.designation : "";
  let sort = filterValues.sort ? filterValues.sort : null;
  let offset = filterValues.offset ? filterValues.offset : null;

  const newdesignation =
    designation &&
    designation.split("%2C") &&
    designation.split("%2C").map((m) => {
      m = m.toUpperCase();
      m = certificationData && certificationData.filter((item) => item.certName == m);
      return m && m[0];
    });
  const newLang =
    lang &&
    lang.split("%2C") &&
    lang.split("%2C").map((m) => {
      m = m.toLowerCase();
      m = languageData && languageData.filter((item) => item.defaultValue === m);
      return m && m[0];
    });
  const newSort = getSortingOption(sort);

  const newrep = rep === "buyer" ? "Buyers" : rep === "seller" ? "Sellers" : "Buyers and Sellers";
  const pg = offset && offset / 20 + 1;
  const modifiedObj = {
    rating,
    recommendation,
    price: { minPrice, maxPrice },
    rep: newrep,
    photo,
    lang: newLang,
    designation: newdesignation,
    sort: newSort,
    pg,
  };

  return modifiedObj;
};
const getMarketingArea = (_id) => {
  let marketingArea = _id && _id.split(":")[1];
  // marketingArea = marketingArea && marketingArea.replace(/-/, " ");

  return marketingArea;
};
const getSecondPart = (str, s, n) => {
  return str && str.split(s)[n];
};
const getCounty = (parserData) => {
  let county;
  const slug_id = parserData && parserData.slug_id && parserData.slug_id.toLowerCase();
  const county_needed_for_uniq = parserData && parserData.county_needed_for_uniq;

  const qlocationLength = slug_id && slug_id.split("_");
  if (
    qlocationLength &&
    qlocationLength.length > 2 &&
    /county/.test(slug_id) &&
    county_needed_for_uniq
  ) {
    county = getSecondPart(slug_id, "_", 1);
  } else {
    county = null;
  }
  return county;
};
const replaceHashWithSpace = (str) => {
  let finalStr;
  finalStr = str && str.replace(/-/g, " ");
  return finalStr;
};
const replaceSpacehWithHash = (str) => {
  let finalStr;
  finalStr = str && str.replace(/ /g, "-");
  return finalStr;
};
const getHeaderCityCountyState = (query) => {
  let showText;
  if (query && query.postalCode && query.postalCode.length > 0) {
    showText = query.postalCode;
  } else if (query && query.city && query.county && query.city.length > 0 && query.state_code) {
    showText =
      query.city +
      ", " +
      replaceHashWithSpace(query.county) +
      ", " +
      query.state_code.toUpperCase();
  } else if (query && !query.city && query.county && query.state_code) {
    showText = replaceHashWithSpace(query.county) + ", " + query.state_code.toUpperCase();
  } else if (query && query.city && query.city.length > 0 && query.state_code) {
    showText = query.city + ", " + query.state_code.toUpperCase();
  } else {
    showText = query && query.name;
  }

  showText = showText ? capitalize(showText) : "";
  return showText;
};

module.exports = {
  filterSlugGenerator,
  getMarketingArea,
  queryfilterObjectGenerator,
  getSecondPart,
  getCounty,
  replaceHashWithSpace,
  replaceSpacehWithHash,
  getHeaderCityCountyState,
};
